import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';

const ZellePayment = ({
    recipientEmail,
    amount,
    description = '',
    qrSize = 250,
    showBackButton = false,
    qrOnly = false,
    recipientToken = '',
    recipientName = '',
    onBack = () => { }
}) => {
    const [isMobile, setIsMobile] = useState(false);
    const [isAppAttempted, setIsAppAttempted] = useState(false);
    const [qrValue, setQrValue] = useState('');

    useEffect(() => {
        const checkMobile = () => {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            if (/android|iPad|iPhone|iPod/i.test(userAgent)) {
                setIsMobile(true);
            }
        };

        checkMobile();
    }, []);

    useEffect(() => {
        const createEnhancedQrCode = () => {
            const token = recipientToken || recipientEmail;
            if (!token || !amount) {
                console.error('Missing required Zelle payment information');
                return '';
            }
            const zelleData = {
                "name": recipientName,
                "action": "payment",
                "token": token,
                "amount": `${amount}`,
                "memo": description || ""
            };
            console.warn(zelleData)
            const jsonString = JSON.stringify(zelleData);
            const base64Encoded = btoa(jsonString);
            return `https://enroll.zellepay.com/qr-codes?data=${base64Encoded}`;
        };

        const qrUrl = createEnhancedQrCode();
        setQrValue(qrUrl);
    }, [recipientEmail, recipientName, recipientToken, amount, description]);
    const handleZelleAppOpen = () => {
        window.open(qrValue, '_blank');
        setIsAppAttempted(true);
    };

    return (
        <div className="zelle-payment-container">
            <div className="payment-options">
                <div className="payment-details">
                    {showBackButton && (
                        <button onClick={onBack} className="back-btn">
                            Back
                        </button>
                    )}
                </div>
                {
                    !qrOnly && (
                        <hr />
                    )
                }
                <div className="qr-code-section">
                    {
                        !qrOnly && (
                            <h3
                                className='zelle-app-heading'
                                style={{
                                    textAlign: 'center'
                                }}
                            >Scan with Zelle App</h3>
                        )
                    }
                    {qrValue && (
                        <div className="qr-code-container">
                            <QRCodeSVG value={qrValue} size={qrSize} />
                        </div>
                    )}
                    <p className="instructions">
                        Open your Zelle app and scan this QR code to complete the payment.
                    </p>
                    {amount && (
                        <p className="payment-amount">
                            Amount: ${amount?.replace('$', '')}
                            {description && <span className="payment-memo"> - {description}</span>}
                        </p>
                    )}
                </div>
                {
                    !qrOnly && (
                        <>
                            <hr />
                        </>
                    )
                }
                <div className="app-link-section">
                    {
                        !qrOnly && (
                            <h3
                                className='zelle-app-heading'
                                style={{
                                    textAlign: 'center'
                                }}
                            >Open Zelle Payment</h3>
                        )
                    }
                    <button type="button" onClick={handleZelleAppOpen} className="zelle-app-btn">
                        Open Payment Link
                    </button>

                    {isAppAttempted && (
                        <p className="app-status">
                            If you don't have the Zelle app, you can download it here:
                            <a
                                href="https://www.zellepay.com/go/zelle"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="get-zelle-link"
                            >
                                Get Zelle
                            </a>
                        </p>
                    )}
                </div>
            </div>

            <style jsx>{`
        .zelle-payment-container {
          margin: 0 auto;
          padding: 0px;
          font-family: Arial, sans-serif;
        }
        #wc-zelle-form.order-details .instructions {
            margin-bottom: 10px;
        }

        #wc-zelle-form.order-details .app-status {
            text-align: center;
        }
        #wc-zelle-form .form-group {
          margin-bottom: 15px;
        }
        label {
          display: block;
          margin-bottom: 5px;
          font-weight: bold;
        }
        #wc-zelle-form input {
          width: 100%;
          padding: 8px;
          border: 1px solid #ccc;
          border-radius: 4px;
        }
        #wc-zelle-form button {
          background-color: #6a4fcc;
          color: white;
          border: none;
          padding: 10px 15px;
          border-radius: 4px;
          cursor: pointer;
          font-size: 16px;
          width: 100%;
        }
        #wc-zelle-form button:hover {
          background-color: #5a3fb9;
        }
        #wc-zelle-form .back-btn {
          background-color: #666;
          margin-top: 15px;
        }
        #wc-zelle-form .payment-options {
          display: flex;
          grid-template-columns: 1fr;
          flex-direction: column;
        }
        @media (min-width: 768px) {
          .payment-options {
            grid-template-columns: 1fr 1fr;
          }
          .payment-details {
            grid-column: 1 / -1;
          }
        }
        .qr-code-container {
          display: flex;
          justify-content: center;
          margin: 20px 0;
          margin-top: 0px;
        }
        .zelle-app-heading {
          color: #000;
          font-size: 22px;
          margin-bottom: 6px;
        }
        .instructions {
          font-size: 14px;
          color: #666;
          text-align: center;
        }
        .payment-amount {
          text-align: center;
          font-weight: bold;
          margin-top: 8px;
          color: #333;
        }
        .payment-memo {
          font-weight: normal;
          font-style: italic;
        }
        .app-status {
          font-size: 14px;
          margin-top: 10px;
        }
        .get-zelle-link {
          display: block;
          color: #6a4fcc;
          margin-top: 5px;
          text-decoration: none;
        }
      `}</style>
        </div>
    );
};

export default ZellePayment;